var map = {
	"./Blue/0.png": 34730,
	"./Blue/1.png": 12992,
	"./Blue/2.png": 97026,
	"./Blue/3.png": 5251,
	"./Blue/4.png": 81783,
	"./Blue/5.png": 58855,
	"./Blue/6.png": 1540,
	"./Blue/7.png": 97947,
	"./Blue/8.png": 53784,
	"./Gray/0.png": 8541,
	"./Gray/1.png": 5183,
	"./Gray/2.png": 74337,
	"./Gray/3.png": 60094,
	"./Gray/4.png": 71237,
	"./Gray/5.png": 62010,
	"./Gray/6.png": 88308,
	"./Gray/7.png": 58303,
	"./Gray/8.png": 57220,
	"./Green/0.png": 81719,
	"./Green/1.png": 4219,
	"./Green/2.png": 5484,
	"./Green/3.png": 3035,
	"./Green/4.png": 12113,
	"./Green/5.png": 12314,
	"./Green/6.png": 50744,
	"./Green/7.png": 36347,
	"./Green/8.png": 10277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71703;